// @flow

import _ from "lodash";
import React, { Component } from "react";
import { compose } from "react-apollo";
import { withRouter } from "react-router";
import { withLinkUser, withNetworkUser } from "../../data/accounts";
import { withCreateSession } from "../../data/session";
import WithLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";
import Spinner from "../../components/Spinner/Spinner";
import HeaderMessage from "../../components/HeaderMessage/HeaderMessage";
import { isPositiveInteger } from "../../utils/";

import WithTracker from "../../components/WithTracker/WithTracker";

// FIXME
// type Props = {
//   history: RouterHistory,
//   secret: string,
//   projectId: string,
//   timeLimit: number
//   userData
// } & userQueryResult &
//   linkUserMutationResult;

type Props = Object;

class LinkedSession extends Component<Props, Object> {
  constructor(props: Props) {
    super(props);

    this.validateProps(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !_.isEqual(this.props, nextProps) || !_.isEqual(this.state, nextState)
    );
  }

  validateProps(props: Props) {
    const isValidKind = function(kind: string): boolean {
      return _.includes(["seconds", "questions"], kind);
    };

    const propsValid =
      props.projectId &&
      isPositiveInteger(props.limitValue) &&
      isValidKind(props.limitKind) &&
      props.assignmentId &&
      isPositiveInteger(props.maxBonusCents) &&
      isPositiveInteger(props.basePayCents);

    if (!propsValid) {
      alert(
        "We detected a problem with your HIT. Sorry for that! Please return to the HIT for now and we'll try to fix it."
      );
      console.error(props);
      throw new Error(`Required prop invalid!`);
    }
  }

  auth() {
    this.props
      .linkUser({ secret: this.props.secret })
      .then(response => {
        window.localStorage.setItem(
          "graphcoolToken",
          response.data.authWorker.token
        );
        this.props.userData.refetch();
        this.props
          .createSession({
            variables: {
              userId: response.data.authWorker.id,
              projectId: this.props.projectId,
              limitValue: this.props.limitValue,
              limitKind: this.props.limitKind,
              assignmentId: this.props.assignmentId,
              maxBonusCents: this.props.maxBonusCents,
              basePayCents: this.props.basePayCents
            }
          })
          .then(res => {
            this.props.history.push(`/projects/${this.props.projectId}`);
          });
      })
      .catch(e => {
        alert("Couldn't create your link account, please try again later"); // TODO - redirect to error page
        throw e;
      });
  }

  componentDidMount() {
    this.props.setHeader(<HeaderMessage>Welcome!</HeaderMessage>);
    this.auth();
  }

  render() {
    return <Spinner />;
  }
}

const extendComponent = compose(
  withNetworkUser,
  withLinkUser,
  WithLoadingIndicator,
  WithTracker,
  withRouter,
  withCreateSession
);

export default extendComponent(LinkedSession);



// WEBPACK FOOTER //
// ./src/pages/LinkedSession/LinkedSession.js